import { useLingui } from "@lingui/react/macro";
import { IconCheck, IconPlus } from "@tabler/icons-react";

/**
 * Returns polymorphic data for create/edit form modals.
 *
 * @param {object} params
 * @param {string} params.createLabel - Translated label for create mode (e.g. `t\`Crear ítem\``)
 * @param {string} params.editLabel - Translated label for edit mode (e.g. `t\`Editar ítem\``)
 * @param {boolean} params.isEditing
 * @returns {{ modalTitle: string, submitIcon: JSX.Element, submitText: string }}
 */
export function usePolymorphicData({ createLabel, editLabel, isEditing }) {
	const { t } = useLingui();
	return {
		modalTitle: isEditing ? editLabel : createLabel,
		submitIcon: isEditing ? <IconCheck /> : <IconPlus />,
		submitText: isEditing ? t`Guardar` : t`Crear`,
	};
}
